import { Component, Input, TrackByFunction } from '@angular/core'
import { ButtonDisplayType, ButtonSize } from '@ftr/foundation'
import { Permission, Restriction } from '../permissions-list/user-group-permissions-list.component'

@Component({
  selector: 'ftr-user-group-permissions-list-item',
  templateUrl: './user-group-permissions-list-item.component.html',
})
export class UserGroupPermissionsListItemComponent {
  @Input() permission: Permission

  readonly buttonDisplayType = ButtonDisplayType
  readonly buttonSize = ButtonSize

  toggleRestrictedVisibility(permission: Permission): void {
    permission.isExpanded = !permission.isExpanded
  }

  trackRestrictionBy: TrackByFunction<Restriction> = (_idx: number, item: Restriction) => {
    return item.entityType
  }

  trackNameBy: TrackByFunction<string> = (_idx: number, item: string) => {
    return item
  }
}
